export default "__VITE_ASSET__DSYGsc57__"